const GET_MOVIE = 'flixfrenzy/redux/GET_MOVIE';

// eslint-disable-next-line default-param-last
const playMovieReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MOVIE:
      return action.payload;
    default:
      return state;
  }
};

export const getMovie = (playMovieProps) => (dispatch) => {
  dispatch({
    type: GET_MOVIE,
    payload: playMovieProps,
  });
};

export default playMovieReducer;
